<template>
  <input
    type="text"
    class="form-item"
    placeholder="Answer here"
    aria-label="Answer here"
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="false"
    :disabled="locked"
    v-bind:value="answer"
    v-on:input="input($event.target.value)"
    @keyup.enter="submit()"
  />
</template>

<script>
export default {
  props: {
    answer: String,
    locked: Boolean
  },
  methods: {
    input(value) {
      this.$emit('answer-updated', value)
    },
    submit() {
      this.$emit('submit')
    }
  }
}
</script>
